import { Card, Seat, cardToData } from "@ravalmatic/bridge-engine/core";
import { NineSliceContainer } from "@ravalmatic/catafractum-utils";

export class CardinalContainer extends Phaser.GameObjects.Container {

    private readonly background: Phaser.GameObjects.Image;
    private readonly cardinalLabel: Phaser.GameObjects.Text;
    private readonly tricksLabel: Phaser.GameObjects.Text;
    private readonly lastCardContainer: Phaser.GameObjects.Container;
    private readonly lastCardRow: Phaser.GameObjects.Container;
    private readonly lastCardLabel: Phaser.GameObjects.Text;
    private readonly lastCardSuit: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, seat: Seat) {

        super(scene);

        this.setScale(.625);
        this.background = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "cardinal_container_small");
        const style = {
            fontFamily: "Baloo2-Bold",
            fontSize: "48px",
            color: "#ffffff"
        };
        this.cardinalLabel = new Phaser.GameObjects.Text(scene, 0, -4, ["N", "E", "S", "W"][seat], style);
        this.cardinalLabel.setOrigin(.5);
        this.tricksLabel = new Phaser.GameObjects.Text(scene, 29, -4, "0", style);
        this.tricksLabel.setOrigin(.5).setVisible(false);
        this.add([this.background, this.cardinalLabel, this.tricksLabel]);

        const frame = scene.textures.getFrame("texture_atlas_1", "contract_bid_bg");
        if (!frame) {
            throw new Error("Missing atlas frame: contract_bid_bg");
        }
        const width = 88;
        const height = 52;
        const scale = Math.min(1, width / frame.width, height / frame.height);
        const lastCardBackground = new NineSliceContainer(
            scene, 0, 0, "texture_atlas_1", "contract_bid_bg", width / scale, height / scale, 48
        ).setScale(scale);
        this.lastCardContainer = new Phaser.GameObjects.Container(scene).setScale(1.15).setVisible(false);
        this.lastCardLabel = new Phaser.GameObjects.Text(scene, 0, 0, "", {
            fontFamily: "Baloo2-SemiBold",
            fontSize: "42px",
            color: "#1F252D"
        }).setOrigin(.5);
        this.lastCardSuit = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "spades_icon");
        this.lastCardRow = new Phaser.GameObjects.Container(
            scene, 0, -2, [this.lastCardLabel, this.lastCardSuit]
        );
        this.lastCardContainer.add([lastCardBackground, this.lastCardRow]);
        this.add(this.lastCardContainer);
    }

    public showPlay(): void {

        this.background.setFrame("cardinal_container_big");
        this.cardinalLabel.setX(-29);
        this.tricksLabel.setText("0").setVisible(true);
    }

    public setTricksWon(tricks: number): void {

        this.tricksLabel.setText(`${tricks}`);
    }

    public setLastCard(card: Card | null): void {

        this.lastCardContainer.setVisible(card !== null);
        if (card === null) {
            return;
        }
        const { value, suit } = cardToData(card);
        this.lastCardLabel.setText(value).setColor(suit === 1 || suit === 2 ? "#D92727" : "#1F252D");
        this.lastCardSuit.setFrame(["spades_icon", "hearts_icon", "diamonds_icon", "clubs_icon"][suit]);
        this.lastCardSuit.setScale(32 / this.lastCardSuit.height);
        const width = this.lastCardLabel.displayWidth + 4 + this.lastCardSuit.displayWidth;
        this.lastCardLabel.setX(-width / 2 + this.lastCardLabel.displayWidth / 2);
        this.lastCardSuit.setX(width / 2 - this.lastCardSuit.displayWidth / 2);
        this.lastCardRow.setScale(Math.min(1, 80 / width, 36 / this.lastCardLabel.displayHeight));
        this.lastCardContainer.setY(this.background.height / 2 + 10 + 26 - 2 / this.scaleY);
    }
}
